/**
 * Timing for RevealWords: when each word of a reply starts to appear.
 * A long reply speeds up so the whole reveal never takes much longer than WORD_REVEAL_CAP_MS.
 */
export const WORD_STAGGER_MS = 80;
export const WORD_REVEAL_CAP_MS = 3500;
export const WORD_MIN_STAGGER_MS = 25;
export const WORD_DURATION_MS = 700;


/** Gap between two words appearing, for a reply of this many words. */
export function staggerFor(wordCount: number): number {
  return Math.min(WORD_STAGGER_MS, Math.max(WORD_MIN_STAGGER_MS, WORD_REVEAL_CAP_MS / Math.max(1, wordCount)));
}

export interface WordSchedule {
  /** Per word: how long after it first rendered it starts to appear (ms). Fixed once set. */
  delays: number[];
  /** When (performance.now) the next word may start. */
  nextSlot: number;
}

/** Gives every word not yet scheduled its slot, behind the ones already queued. Safe to call again for the same words. */
export function scheduleWords(schedule: WordSchedule, wordCount: number, now: number): WordSchedule {
  for (let w = schedule.delays.length; w < wordCount; w++) {
    const slot = Math.max(now, schedule.nextSlot);
    schedule.delays[w] = slot - now;
    schedule.nextSlot = slot + staggerFor(wordCount);
  }
  return schedule;
}

